<template>
  <div :style="{background : dataTypeInfo.default_bar_type === 'gradient' ? 'rgba(255, 255, 255, 0)' : 'rgba(255, 255, 255, 0.8)' }" style="width: 350px; height: 40px; position:absolute; bottom: 50px;left: 50%;transform: translateX(-50%); border-radius: 5px;">
    <canvas
      class="color-bar"
      id="myCanvas"
      :width="bar_length"
      :height="bar_height"
    ></canvas>
  </div>
</template>
<script>
export default {
  props: {
    colorType: String,
    drawValue: String,
    colorRangeDefault: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      min: 0,
      max: 700,
      minSet: 0,
      maxSet: 0,
      visibleMin: false,
      visibleMax: false,
      colorBarMax: 1000,
      bar_length: 350,
      bar_height: 55,
      c: null,
      ctx: null
    };
  },
  computed: {
    colorBar() {
      return new colorIntensity.getColorBar({
        dataType: this.drawValue,
        colorType: this.colorType
      });
    },
    dataTypeInfo() {
      return G_SENSOR_DATA_TYPE_INFO.find(x => x.value === this.drawValue);
    }
  },
  mounted() {
    this.initCanvas();
    this.getColors();
  },
  watch: {
    visibleMin() {
      if (this.visibleMin) {
        this.minSet = this.min;
      }
    },
    visibleMax() {
      if (this.visibleMax) {
        this.maxSet = this.max;
      }
    },
    drawValue() {
      this.getColors();
    },
    colorType() {
      this.getColors();
    },
    dataTypeInfo() {
      this.$emit('update:barType', this.dataTypeInfo.default_bar_type)
    }
  },
  methods: {
    onChangeMin(val) {
      if (!val) val = 0;
      if (val < 0) val = 0;
      this.min = val;
      this.handleColorBarChange([this.min, this.max]);
    },
    onChangeMax(val) {
      if (!val && val != 0) return;
      val = val > this.colorBarMax ? this.colorBarMax : val;
      this.max = val;
      this.handleColorBarChange([this.min, this.max]);
    },
    initCanvas() {
      // 真实渐变
      this.c = document.getElementById("myCanvas");
      this.ctx = this.c.getContext("2d");
    },
    drawCanvas() {
      console.log("drawCanvas");
      this.clearCanvas();
      if (this.dataTypeInfo.default_bar_type === "gradient") {
        this.draw1();
      } else {
        this.draw4();
      }
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, this.c.width, this.c.height);
    },
    getColors() {
      let color_range_max = this.dataTypeInfo.color_range_max;
      this.colorBarMax = color_range_max * 2;
      if (this.colorRangeDefault) {
        this.min = this.colorRangeDefault[0];
        this.max = this.colorRangeDefault[1];
      } else {
        this.min = this.dataTypeInfo.color_range_min;
        this.max = color_range_max;
      }

      this.handleColorBarChange([this.min, this.max]);
      this.drawCanvas();
    },
    // 真实渐变
    draw1() {
      var bar_length = this.bar_length;
      var bar_data = this.colorBar.data;
      var bar_max = bar_data[bar_data.length - 1].max;
      var grd = this.ctx.createLinearGradient(0, 0, bar_length, 0);
      var lastRate = 0;
      var idx = 0;
      for (var b of bar_data) {
        grd.addColorStop(b.rate, b.bgcolor);
        let rate = b.max / bar_max;
        lastRate = rate;
        idx++;
      }
      this.ctx.fillStyle = grd;
      this.ctx.fillRect(0, 35, bar_length, 30);

      this.ctx.font = "12px Verdana";
      this.ctx.fillStyle = "white";
      this.ctx.fillText(this.min, 4, 47);
      this.ctx.fillText(this.max, bar_length - 25, 47);
    },

    // 真实阶梯
    draw2() {
      var bar_length = this.bar_length;
      var bar_data = this.colorBar.data;
      var bar_max = bar_data[bar_data.length - 1].max;
      var lastRate = 0;
      for (var b of bar_data) {
        let rate = b.max / bar_max;
        this.ctx.fillStyle = b.bgcolor;
        this.ctx.fillRect(lastRate * bar_length, 30, rate * bar_length, 30);
        this.ctx.fillStyle = b.fgcolor;
        this.ctx.textAlign = "center";
        this.ctx.font = "13px Verdana";
        this.ctx.fillText(
          b.description,
          ((rate - lastRate) / 2 + lastRate) * bar_length,
          18
        );
        lastRate = rate;
      }
    },

    // 等比渐变
    draw3() {
      var bar_length = this.bar_length;
      var bar_data = this.colorBar.data;
      var bar_max = bar_data[bar_data.length - 1].max;
      var grd_eq = this.ctx.createLinearGradient(0, 0, bar_length, 0);
      var lastRate = 0;
      var idx = 0;
      for (var b of bar_data) {
        grd_eq.addColorStop(
          (1 / bar_data.length) * idx + 1 / (2 * bar_data.length),
          b.bgcolor
        );
        let rate = b.max / bar_max;
        lastRate = rate;
        idx++;
      }
      this.ctx.fillStyle = grd_eq;
      this.ctx.fillRect(0, 30, bar_length, 30);
    },
    // 等比阶梯
    draw4() {
      var bar_length = this.bar_length;
      var bar_data = this.colorBar.data;
      var idx = 0;
      let block_width = bar_length / bar_data.length;
      for (var b of bar_data) {
        this.ctx.fillStyle = b.bgcolor;
        this.ctx.fillRect(block_width * idx, 35, block_width, 30);
        this.ctx.textAlign = "center";
        // this.ctx.fillStyle = b.fgcolor;
        // this.ctx.textAlign = "center";
        // this.ctx.font = "13px Verdana";
        // let x = block_width * (idx + 0.5);
        // console.log(x);
        // this.ctx.fillText(b.description, x, 18);

        if (this.colorBar.show_desc) {
          this.ctx.fillStyle = b.fgcolor;

          this.ctx.font = "13px Verdana";
          this.ctx.fillText(b.description, x, 20);
        }

        if (this.colorBar.show_max_num) {
          this.ctx.fillStyle = "#000";
          this.ctx.font = "12px Verdana";
          if (idx < bar_data.length - 1) {
            this.ctx.fillText(b.max, block_width * (idx + 1), 30);
          }
        }

        idx++;
      }
    },

    handleColorBarChange(v) {
      this.min = v[0];
      this.max = v[1];
      // this.$store.commit("setColorRange", v);
    }
  }
};
</script>

<style scoped>
.color-bar {
  display: inline-block;
  position: absolute;
  bottom: 2px;
  z-index: 10;
  left: 50%;
  transform: translateX(-50%);
  vertical-align: middle;
}

.color-bar-val {
  position: absolute;
  bottom: 52px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  z-index: 10;
  height: 25px;
  line-height: 25px;
}
.custom-button {
    width: 26px;
    color: #fff;
    font-size: 10px;
    line-height: 18px;
    text-align: center;
    background-color: #ee0a24;
    border-radius: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/colorBar.vue